import * as api from '@codametrix/client-api';
import { bf as createAction, bh as commonActions, bi as toServiceLineSlug, bj as emptyPageable, bk as get, H as fetchCodeBenchLayoutConfiguration } from './code-bench.actions-BveYxkDF.mjs';
import { c as commonEnums, M as Methods } from './enums-CbPAb7iQ.mjs';

const { Launch } = commonActions;
const { FilterTypes } = commonEnums;
const caseRunAvailable = createAction(Launch.CASE_DETAIL);
const billingGroupAvailable = createAction(Launch.BILLING_GROUP);
const getBillingGroup = async (billingGroupId, dispatch)=>{
    // TORESOLVE: This will need to be paramd for the service line.
    const searchParams = new URLSearchParams({
        page: '0',
        pageSize: '25',
        sort: 'dateOfService,DESC'
    });
    searchParams.append('sort', 'id,DESC');
    let body = [];
    body.push({
        key: `billing_group_id`,
        terms: [
            `${billingGroupId}`
        ],
        type: FilterTypes.EQ
    });
    const slPath = get().path;
    const { caseListVersion } = get();
    const billingGroupPageable = await api.requestJSON(`${slPath}/caseinstance/list/${caseListVersion}?${searchParams.toString()}`, {
        method: Methods.POST,
        body: JSON.stringify(body)
    });
    dispatch(billingGroupAvailable(billingGroupPageable));
    return billingGroupPageable;
};
const loadCase = async (caseRun, dispatch, guidMode = 'false')=>{
    var _caseRun_service_line;
    const launchConfig = {
        serviceLine: toServiceLineSlug(String((_caseRun_service_line = caseRun.service_line) !== null && _caseRun_service_line !== void 0 ? _caseRun_service_line : '')),
        caseId: guidMode === 'true' ? caseRun.case_uid : caseRun.case_id,
        processId: guidMode === 'true' ? caseRun.process_instance_guid : caseRun.process_instance_id
    };
    await loadCaseCall(caseRun, dispatch);
    return {
        url: `/${launchConfig.serviceLine}/case/${launchConfig.caseId}/case-run/${launchConfig.processId}`
    };
};
const loadCaseFromURL = async (caseRun, dispatch)=>{
    return await loadCaseCall(caseRun, dispatch);
};
const loadCaseCall = async (caseRun, dispatch)=>{
    dispatch(caseRunAvailable(caseRun));
    const promises = [];
    // three async actions that happen in parallel
    // 1. get a billing group
    // 2. get the code descriptions - neither of which is blocking.
    // 3. get the code-bench layout configuration
    if (caseRun.billing_group_id) {
        const billingGroup = getBillingGroup(caseRun.billing_group_id, dispatch);
        promises.push(billingGroup);
    } else {
        dispatch(billingGroupAvailable(emptyPageable));
    }
    // Fetch code-bench layout configuration
    if (caseRun.tenant_name && caseRun.service_line) {
        const fetchCodeBenchConfig = async ()=>{
            try {
                /*
          The below throws this error:
            TS2345: Argument of type 'ThunkFunctionAction<any, BenchApplicationState, unknown>' is not assignable to parameter of type 'Action<string>'.
          Ensure why, added a ts-ignore, seems to work otherwise.
         */ dispatch(// @ts-ignore
                fetchCodeBenchLayoutConfiguration({
                    tenantId: caseRun.tenant_uid,
                    serviceLine: caseRun.service_line
                }));
            } catch (error) {
                console.warn('Failed to fetch code-bench layout configuration:', error);
            }
        };
        promises.push(fetchCodeBenchConfig());
    }
    await Promise.all(promises);
    return;
};

var cases_action = /*#__PURE__*/Object.freeze({
  __proto__: null,
  billingGroupAvailable: billingGroupAvailable,
  caseRunAvailable: caseRunAvailable,
  getBillingGroup: getBillingGroup,
  loadCase: loadCase,
  loadCaseCall: loadCaseCall,
  loadCaseFromURL: loadCaseFromURL
});

export { loadCaseFromURL as a, cases_action as c, loadCase as l };
//# sourceMappingURL=cases.action-MvAvaOGn.mjs.map
